import { Component, Input, OnInit } from '@angular/core';
import { ModalRef } from '@shared/ui';

@Component({
  template: `
    <!-- TODO: Port modal to webapp stack  -->
  `,
})
export class RequestMilestoneModalComponent implements OnInit {
  @Input() bidId: number;
  @Input() bidderId: number;
  @Input() projectId: number;

  constructor(private modalRef: ModalRef<RequestMilestoneModalComponent>) {}

  ngOnInit() {
    // FIXME: port this modal to the webapp stack
    // TODO: get the employer public from Auth + Datastore
    // TODO: get the project currency from Datastore
    // TODO: get the bidder id from Datastore (from the bid)?
    (<any>window).messagingWebappCompatModals.RequestMilestoneModal.initModal(
      {
        bidId: this.bidId,
        projectId: this.projectId,
        bidderId: this.bidderId,
        employerUsername: 'fixme',
        // currencyDetails: project.currency,
      },
      () => undefined,
      true,
    );
  }

  close() {
    this.modalRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/request-milestone-modal/request-milestone-modal.component.ts